import React from 'react';
import styled from '@emotion/styled';
import { Typography } from '../typography/typography';
import { BreakpointSizes, mq } from '@taleemabad/dsm/themes';

interface TableRow {
  cells: { content: string | number; colSpan?: number; className?: string }[];
}

interface TableProps {
  rows: TableRow[];
}

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    border: 1px solid var(--md-sys-color-shadow);
    padding: var(--rk-spacing-md);
    text-align: left;
    word-wrap: break-word;
  }

  .empty-field {
    width: 30%;
    min-width: 30%;
    height: 22px;
  }
  .header {
    font-weight: bold;
  }
  ${mq(BreakpointSizes.xs)} {
    td {
      padding: var(--rk-spacing-sm);
      white-space: nowrap;
    }
  }
`;
const StyledTypography = styled(Typography)`
  ${mq(BreakpointSizes.xs)} {
    ${(props) =>
      (props.variant === 'textTitleMediumSurface' ||
        props.variant === 'textTitleSmallonSurface') &&
      `
      font-size: var(--md-sys-typescale-body-small-size);
    `}
  }
`;

export const Table: React.FC<TableProps> = ({ rows }) => {
  return (
    <StyledTable>
      <tbody>
        {rows.map((row, rowIndex) => (
          <tr key={rowIndex}>
            {row.cells.map((cell, cellIndex) => (
              <td
                key={cellIndex}
                colSpan={cell.colSpan}
                className={cell.className}
              >
                <StyledTypography
                  variant={
                    cellIndex !== 1
                      ? 'textTitleMediumSurface'
                      : 'textTitleSmallonSurface'
                  }
                >
                  {cell.content}
                </StyledTypography>
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </StyledTable>
  );
};
